function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { EnumDateFormat } from '../constants/enumDateFormat';
var DateHelper = /*#__PURE__*/ _createClass(function DateHelper() {
    _classCallCheck(this, DateHelper);
    _defineProperty(this, "convertToCommonFormat", function (date) {
        var timestampLength = 10;
        var isSeconds = typeof date === 'number' && date.toString().length === timestampLength;
        dayjs.extend(utc);
        if (isSeconds) {
            return dayjs.unix(date).utc().format(EnumDateFormat.CommonDate);
        }
        return dayjs(date).utc().format(EnumDateFormat.CommonDate);
    });
    _defineProperty(this, "convertByFormat", function (date, format) {
        return dayjs(date).format(format);
    });
    _defineProperty(this, "convertStingToTimestamp", function (string) {
        return dayjs(string).valueOf();
    });
    _defineProperty(this, "getEndDayDate", function () {
        var startDate = new Date();
        startDate.setUTCHours(23, 59, 59, 999);
        return startDate;
    });
    _defineProperty(this, "getStartDayDate", function () {
        var startDate = new Date();
        startDate.setUTCHours(0, 0, 0, 0);
        return startDate;
    });
    _defineProperty(this, "convertZeroTimezoneToLocal", function (date) {
        var timestampZeroTimezone = date.getTime();
        var differenceWithZeroTimezoneTimestamp = date.getTimezoneOffset() * 60 * 1000;
        var localTimestampDate = timestampZeroTimezone - differenceWithZeroTimezoneTimestamp;
        return new Date(localTimestampDate);
    });
    _defineProperty(this, "convertLocalToZeroTimezone", function (date) {
        var zeroTimezone = 'Africa/Accra';
        var lang = 'en-US';
        var stringZeroTimezone = date.toLocaleString(lang, {
            timeZone: zeroTimezone
        });
        return new Date(stringZeroTimezone);
    });
    _defineProperty(this, "convertDateToSeconds", function (date) {
        return Math.floor(date.getTime() / 1000);
    });
});
export default new DateHelper();
